//external
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
//internal
import { deleteProductCategorySite, getProductCategorySite } from 'services/rtpi/productCategorySite/service';
import history from 'services/history';
import { startRequest, finishRequest } from 'store/modules/loading/actions';
import ContentPanel from 'components/ContentPanel';
import { setMessage } from 'store/modules/message/action';
import { sanitizeErrorUI } from 'utils/errorUtil';
//style
import { Attr, AttrName } from './styled';
import { Button, ButtonContainer } from 'styles/components';

export default function ProductCategorySiteDelete({match}) {
  const productCategorySiteId = match.params.id;
  const message = useSelector(state => state.message.data);
  const [productCategorySite, setProductCategorySite] = useState();

  const dispatch = useDispatch();

  useEffect(() => {
    if (productCategorySiteId) {
      dispatch(startRequest());
      getProductCategorySite(productCategorySiteId).then(data => {
        setProductCategorySite(data.data);
      }).catch(err => {
        dispatch(setMessage(sanitizeErrorUI(err)));
      }).finally(() => {
        dispatch(finishRequest());
      });
    }
  }, [dispatch, productCategorySiteId]);

  async function handleDelete () {
    dispatch(startRequest());
    deleteProductCategorySite(productCategorySiteId).then(data => {
      history.push('/premixapp/rtpi_product_category_site')
    }).catch(err => {
      dispatch(setMessage(sanitizeErrorUI(err)));
    }).finally(() => {
      dispatch(finishRequest());
    });
  }

  async function handleBack () {
    history.goBack();
  }

  return (
    <>
      <ContentPanel title="Deseja excluir esta categoria de produtos do site?" message={message}>
        {productCategorySite && <>          
          <AttrName>Descrição:</AttrName>
          <Attr>{productCategorySite.description}</Attr>
          <AttrName>Status:</AttrName>
          <Attr>{productCategorySite.active ? 'Ativo' : 'Inativo'}</Attr>
          <ButtonContainer>
            <br />
            <Button left={true} cancel={true} onClick={handleBack}>
              Voltar
            </Button>
            <Button onClick={handleDelete}>
              Excluir
            </Button>
          </ButtonContainer>
        </>}
      </ContentPanel>
    </>
  )
}